import { render } from "./SFAInstalls.vue?vue&type=template&id=b0e2ba26"
import script from "./SFAInstalls.vue?vue&type=script&lang=js"
export * from "./SFAInstalls.vue?vue&type=script&lang=js"

import exportComponent from "/home/desarollo2/Documents/GitHub/dicora-customers-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__